import React from 'react';
import { Button } from '@ditioas/web-ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import FullscreenMessageWrapper from 'components/FullscreenMessageWrapper/FullscreenMessageWrapper';

import { DitioMark } from '../Alerts/ReadOnlyAlert/DitioMark';

const LoggedOut = () => {
  const { t } = useTranslation();

  return (
    <FullscreenMessageWrapper id="logged-out" className="h-screen">
      <DitioMark className="fill-brand w-40" />
      <h2 className="heading-lg my-4">{t('LoggedOut.Heading')}</h2>
      <p className="body-sm">{t('LoggedOut.Description')}</p>
      <Button data-testid="logged-out.action" asChild>
        <Link to="/">{t('LoggedOut.ActionButtonText')}</Link>
      </Button>
    </FullscreenMessageWrapper>
  );
};

export default LoggedOut;
